export default [
    {
        path: "mailList",
        name: "mailList",
        component: () => import("@/components/mailList/mailListIndex.vue"),
        children: [
            {
                path: "myFriends",
                name: "myFriends",
                component: () => import("@/components/mailList/cModel/myFriends.vue"),
            },
            {
                path: "myGroup",
                name: "myGroup",
                component: () => import("@/components/mailList/cModel/myGroup.vue"),
            },
            {
                path: "newFriends",
                name: "newFriends",
                component: () => import("@/components/mailList/cModel/newFriends.vue"),
            },
            {
                path: "myDep",
                name: "myDep",
                component: () => import("@/components/mailList/cModel/myDep.vue"),
            },
            {
                path: "myOrg",
                name: "myOrg",
                component: () => import("@/components/mailList/cModel/myOrg.vue"),
            },
        ]
    }
]


// WEBPACK FOOTER //
// ./src/routers/mailList.js